var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "centrelink-schedule_svg__a",
  d: "M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V9h14v10c0 .55-.45 1-1 1zM8 11h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  d: "M4 .5a.498.498 0 01.493.42L4.5 1v1.5h9V1c0-.138.057-.262.147-.353.49-.147.615-.09.706 0a.5.5 0 01.14.272L14.5 1v1.5H16c.413 0 .787.17 1.059.441.238.238.397.554.433.906L17.5 4v14c0 .413-.17.787-.441 1.059a1.498 1.498 0 01-.906.433L16 19.5H2a1.497 1.497 0 01-1.492-1.347L.5 18 .51 4c0-.414.166-.791.437-1.064.235-.235.548-.393.9-.428L2 2.5h1.5V1c0-.138.057-.262.147-.353A.498.498 0 014 .5zm12.5 6h-15V17l.008.153c.036.352.194.669.432.907.272.272.648.44 1.06.44h12l.153-.008c.352-.036.669-.194.907-.432.272-.272.44-.647.44-1.06h0V6.5zM8 9.5l.5 3.5-3.5.5-.5-3.5L8 9.5z"
});

var SvgCentrelinkSchedule = function SvgCentrelinkSchedule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCentrelinkSchedule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/centrelink-schedule.0dafc742.svg";
export { ForwardRef as ReactComponent };